import WowsCommerce, { LOG_LEVELS } from '@wg/wows-commerce';
import { DWH_EVENTS } from '@wg/wows-commerce/constants/dwhEvents';

import preloaded from '~/preloaded';


// Shop
export const STOREFRONT_NAME = 'fastgold';
// eslint-disable-next-line import/no-mutable-exports
export let wowsCommerce: WowsCommerce;

const { wsmartStorefrontDebug } = preloaded.settings;


// Shop - init
export function initWowsCommerce() {
    wowsCommerce = new WowsCommerce({
        productsValidationEnabled: false,
        backendUrl: preloaded.urls.wsmartUrl,
        logLevel: wsmartStorefrontDebug ? LOG_LEVELS.DEBUG : LOG_LEVELS.ERROR,
        language: preloaded.settings.languageCode,
        showDevPanel: wsmartStorefrontDebug,
        storefrontName: preloaded.settings.wsmartStorefront,
        userSupportUrl: preloaded.urls.supportUrl,
        fraudDetectionClosableByPlatform: false,
        fraudDetectionDialogEnabled: false,
        webPurchaseConfirmationIframeStyles: {
            backgroundColor: 'transparent',
        },
        analytics: {
            projectName: 'dockyard',
            sendInterval: 3,
            maxBatchSize: 5,
        },
        realm: preloaded.settings.realm,
    });

    if (window.dockyard.urls.wsmartUrl) {
        wowsCommerce.checkPurchaseRestrictionByCountryMismatch();
        wowsCommerce.analytics.addEvent(DWH_EVENTS.BIND_METHOD, { test: 1 });
    }
}
